import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Culture } from '@app/shared/models/system-language/culture.model';
import { ReportType } from '../../models/report-designer.model';

export interface EditReportDialogResult {
  name: string;
  description: string;
  reportTypeId: string;
  cultureId: string;
}

@Component({
  selector: 'app-edit-report-dialog',
  templateUrl: './edit-report-dialog.component.html',
  styleUrls: ['./edit-report-dialog.component.scss']
})
export class EditReportDialogComponent {
  public reportName: string;
  public name: string;
  public description: string;
  public reportTypeId: string;
  public reportTypes: ReportType[];
  public cultureId: string;
  public cultures: Culture[];

  constructor(
    private dialogRef: MatDialogRef<EditReportDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.reportName = data.reportName;
    this.name = data.name ?? '';
    this.description = data.description ?? '';
    this.reportTypeId = data.reportTypeId;
    this.reportTypes = data.reportTypes || [];
    this.cultureId = data.cultureId;
    this.cultures = data.cultures || [];
  }

  close(): void {
    this.dialogRef.close();
  }

  save(): void {
    if (!this.name) {
      return;
    }

    this.dialogRef.close({
      name: this.name,
      description: this.description,
      reportTypeId: this.reportTypeId,
      cultureId: this.cultureId,
    } as EditReportDialogResult);
  }
}
